import { useEffect, useRef } from "react";
import "@/App.css";
import "lenis/dist/lenis.css";
import { ReactLenis } from "lenis/react";
import { LanguageProvider } from "@/lib/i18n";
import { Header } from "@/components/atelier/Header";
import { Hero } from "@/components/atelier/Hero";
import { Manifesto } from "@/components/atelier/Manifesto";
import { BrandBanner } from "@/components/atelier/BrandBanner";
import { Collections } from "@/components/atelier/Collections";
import { Outlet } from "@/components/atelier/Outlet";
import { Shoes } from "@/components/atelier/Shoes";
import { Destination } from "@/components/atelier/Destination";
import { GlobeSection } from "@/components/atelier/GlobeSection";
import { Team } from "@/components/atelier/Team";
import { Reviews } from "@/components/atelier/Reviews";
import { Faq } from "@/components/atelier/Faq";
import { Marquee } from "@/components/atelier/Marquee";
import { Contact } from "@/components/atelier/Contact";
import { FloatingWhatsApp } from "@/components/atelier/FloatingWhatsApp";
import { VisitorPopup } from "@/components/atelier/VisitorPopup";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const id = setInterval(() => {
      if (lenisRef.current?.lenis) {
        window.__lenis = lenisRef.current.lenis;
        clearInterval(id);
      }
    }, 100);
    return () => clearInterval(id);
  }, []);

  return (
    <LanguageProvider>
    <ReactLenis ref={lenisRef} root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="App grain bg-ad-black" data-testid="atelier-landing">
        <Header />
        <main>
          <Hero />
          <Manifesto />
          <BrandBanner />
          <Collections />
          <Outlet />
          <Shoes />
          <Destination />
          <GlobeSection />
          <Marquee />
          <Team />
          <Reviews />
          <Faq />
          <Contact />
        </main>
        <FloatingWhatsApp />
        <VisitorPopup />
      </div>
    </ReactLenis>
    </LanguageProvider>
  );
}

export default App;
